const $ = require('jquery')

$(function () {
  function switchByWidth () {
    $('.js-link-change').each(function () {
      const linkBtn = $(this)[0]

      const nuri_source = linkBtn.dataset.nuriSource
      const nuri_medium = linkBtn.dataset.nuriMedium
      const nuri_campaign = linkBtn.dataset.nuriCampaign
      const nuri_content = linkBtn.dataset.nuriContent
      const nuri_term = linkBtn.dataset.nuriTerm

      let url = linkBtn.dataset.url
      if (!window.matchMedia('(min-width: 580px)').matches) {
        url = url.replace('/pc/', '/sp/')
      }

      let param = '?nuri_campaign=' + nuri_campaign + '&nuri_content=' +
        nuri_content + '&nuri_medium=' + nuri_medium + '&nuri_source=' + nuri_source

      if (nuri_term) {
        param += '&nuri_term=' + nuri_term
      }
      $(this).attr('href', url + param)
    })
  }

  addEventListener('load', switchByWidth())
  addEventListener('onresize', switchByWidth())
})
